<template>
  <modal-template ref="modal" modal-size="xl">
    <template v-slot:title>
      {{ lang.modals.conversation.conversation_msg_org.headline }}
    </template>

    <template v-slot:default>
      <div class="text-left max-h-64 overflow-auto">
        <span v-html="msg"></span>
      </div>
    </template>

    <template v-slot:footer="footerSlotProps">
      <div class="flex gap-4">
        <plain-button color="default" @click="hideModal()">{{
          lang.labels.close
        }}</plain-button>
      </div>
    </template>
  </modal-template>

</template>

<script setup>
import { ref } from "vue";
import ModalTemplate from "./ModalTemplate.vue";

const props = defineProps({
  lang: Object,
  modalData: Object,
});

const modal = ref(null);
const msg = ref("");

const showModal = () => {
  modal.value.showModal();
  init();
};

const hideModal = () => {
  modal.value.hideModal();
};

const init = () => {
  loadMsgData();
};

const loadMsgData = () => {
  axios
    .get(`/web-api/user/conversation/${props.modalData.thread}/show-msg-org`, {
      params: {
        id: props.modalData.id,
      },
    })
    .then((response) => {
      msg.value = response.data.conversationMsg.msg;
    })
    .catch((error) => {
      // console.log(error)
    });
};

defineExpose({
  showModal,
  hideModal,
});
</script>
